export default [
  {
    path: 'management',
    name: 'managementRoot',
    redirect: { name: 'workspaceSettings' },
  },
  {
    path: 'management/company',
    name: 'managementCompany',
    redirect: { name: 'workspaceSettings' },
  },
  {
    path: 'management/team',
    name: 'managementTeam',
    redirect: { name: 'teamSettings' },
  },
  {
    path: 'management/billing',
    name: 'managementBilling',
    redirect: { name: 'billingSettings' },
  },
  {
    path: 'management/project',
    name: 'managementProject',
    component: () => import(/* webpackChunkName: "management" */ './Project.vue'),
  },
];
